<template>
  <ContentWrap>
    <el-alert
      type="info"
      :closable="false"
      show-icon
      title="本所预警聚合：今日开庭 / 即将到期期限 / 逾期任务与期限。只读，跳转对应模块处理。"
      class="mb-12px"
    />
    <el-row :gutter="16" class="mb-16px">
      <el-col :xs="12" :sm="8" :md="4">
        <el-card shadow="hover" class="stat" @click="goHearing">
          <div class="label">今日开庭</div>
          <div class="num">{{ summary?.todayHearingCount ?? '—' }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="8" :md="5">
        <el-card shadow="hover" class="stat" @click="goDeadline">
          <div class="label">即将到期</div>
          <div class="num">{{ summary?.upcomingDeadlineCount ?? '—' }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="8" :md="5">
        <el-card shadow="hover" class="stat" @click="goTask">
          <div class="label">逾期任务</div>
          <div class="num">{{ summary?.overdueTaskCount ?? '—' }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="8" :md="5">
        <el-card shadow="hover" class="stat" @click="goDeadline">
          <div class="label">逾期期限</div>
          <div class="num">{{ summary?.overdueDeadlineCount ?? '—' }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="8" :md="5">
        <el-card shadow="hover" class="stat">
          <div class="label">临期合同</div>
          <div class="num">{{ summary?.expiringContractCount ?? '—' }}</div>
        </el-card>
      </el-col>
    </el-row>
    <div class="mb-12px">
      <el-button type="primary" :loading="loading" @click="load">刷新</el-button>
    </div>
    <el-table v-loading="loading" :data="list" border>
      <el-table-column prop="alertType" label="类型" width="110">
        <template #default="{ row }">{{ typeLabel(row.alertType) }}</template>
      </el-table-column>
      <el-table-column prop="firmCaseNo" label="案号" min-width="120" />
      <el-table-column prop="caseTitle" label="案件" min-width="140" show-overflow-tooltip />
      <el-table-column prop="title" label="标题" min-width="160" show-overflow-tooltip />
      <el-table-column prop="eventTime" label="事件时间" width="170" />
      <el-table-column prop="dueDate" label="到期日" width="110" />
      <el-table-column prop="status" label="状态" width="90" />
      <el-table-column label="去处理" width="100" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="goByType(row.alertType)">打开</el-button>
        </template>
      </el-table-column>
    </el-table>
  </ContentWrap>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import {
  FirmPracticeApi,
  type PracticeAlertItemVO,
  type PracticeAlertSummaryVO
} from '@/api/firm/practice'
import { firmPath } from '@/views/firm-portal/registry/paths'

defineOptions({ name: 'FirmPracticeAlert' })

const router = useRouter()
const loading = ref(false)
const summary = ref<PracticeAlertSummaryVO | null>(null)
const list = ref<PracticeAlertItemVO[]>([])

const typeLabel = (t?: string) => {
  const map: Record<string, string> = {
    HEARING: '开庭',
    DEADLINE: '期限',
    TASK: '任务',
    CONTRACT: '合同'
  }
  return (t && map[t]) || t || '—'
}

const load = async () => {
  loading.value = true
  try {
    const [s, items] = await Promise.all([
      FirmPracticeApi.alertSummary(),
      FirmPracticeApi.alertList(50)
    ])
    summary.value = s
    list.value = items || []
  } finally {
    loading.value = false
  }
}

const goHearing = () => router.push(firmPath('/practice/hearing'))
const goTask = () => router.push(firmPath('/practice/task'))
const goDeadline = () => router.push(firmPath('/practice/deadline'))

const goByType = (t?: string) => {
  if (t === 'HEARING') goHearing()
  else if (t === 'TASK') goTask()
  else if (t === 'DEADLINE') goDeadline()
}

onMounted(load)
</script>

<style scoped>
.stat {
  cursor: pointer;
  margin-bottom: 12px;
}
.label {
  font-size: 13px;
  color: #64748b;
}
.num {
  margin-top: 6px;
  font-size: 24px;
  font-weight: 600;
  color: #1e3a3a;
}
</style>
